'use strict';

import { find } from 'lodash';

import flyinTemplate from './flyin.html';

var flyinController = function($window, $document, $controller, adminService) {
    var vm = this;
    angular.extend(vm, $controller('baseStepController'));

    vm.videoSourceUrl = null;
    vm.windowHeight = null;
    vm.windowWidth = null;
    vm.executionStep = null;

    vm.$onInit = function() {
        vm.initializeStep(vm.$stateParams).then(function (executionStep) {
            vm.executionStep = executionStep;
            vm.windowHeight = $window.innerHeight;
            vm.windowWidth = $window.innerWidth; 

            var flyinParameter =  find(executionStep.ticketStep.parameters, function(p) { 
                return p.argumentName === 'flyInUrl';
            });

            adminService.getFlyInUrl(vm.executionStep.ticketStep.ticketId, flyinParameter.value).then(function(url) {
                vm.videoSourceUrl = url;

                var video = $document[0].getElementById("videoFrame");
                video.onended = function() {
                    vm.transition();
                }
            });
        });
    }
};

flyinController.$inject = [ '$window', '$document', '$controller', 'adminService' ];

export var flyinComponent = {
    name: 'flyin',
    template: flyinTemplate,
    controller: flyinController,
    controllerAs: 'vm',
    bindings: {
        $stateParams: '<'
    }
};

export var flyinRoute = {
    name: 'video',
    url: '/video',
    component: 'flyin'
};